"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const Typography_1 = require("@material-ui/core/Typography");
const react_i18next_1 = require("react-i18next");
const QuickDrawGameCardStyle_1 = require("../../jss/QuickDrawGameCardStyle");
const Bullseye = ({ visible, bullseye, bullseyeText }) => {
    const theme = (0, core_1.useTheme)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const classes = (0, QuickDrawGameCardStyle_1.default)();
    if (!visible || !bullseye) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.winningNumberContainer }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "subtitle1", gutterBottom: true, color: 'textPrimary', className: classes.winningNumberText, component: 'div', style: {
                    paddingBottom: 0,
                    marginBottom: 0
                } }, { children: `${bullseyeText !== null && bullseyeText !== void 0 ? bullseyeText : t('gameDetails.bullseye', 'Bullseye')}:` })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.winningNumber, style: {
                    backgroundColor: 'green',
                    borderColor: theme.palette.grey[400]
                } }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ style: {
                        color: 'white',
                        fontSize: theme.breakpoints.down('md') ? '15px' : '20px'
                    } }, { children: bullseye })) }))] })));
};
exports.default = Bullseye;
//# sourceMappingURL=Bullseye.js.map